import { i18n } from '@lingui/core';
import { messages as fi } from '../locales/fi/messages_fi.js';
import { messages as en } from '../locales/en/messages_en.js';
import { messages as nb } from '../locales/nb/messages_nb.js';
import { messages as da } from '../locales/da/messages_da.js';
import { messages as sv } from '../locales/sv/messages_sv.js';

i18n.load({ nb, en, fi, da, sv });

export default i18n;
